import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from '~/components/Steps/Photos/PhotoLayout';

export function FrontDriversideAngle() {
  return <PhotoLayout {...photoLayoutConfig['frontDriversideAngle']} />;
}
